<!-- <div class="breadcrumb_outer">

  <p>Service Logs Filter:</p>
</div> -->
<div class="Content_outer">
  <mat-toolbar class="top_headerbar">
    <!-- Right-aligned section with actions -->
    <div class="right">
      <div class="all_action_btns">
        <!-- Search field for Username with icon -->
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by User Name"
            [(ngModel)]="clientName"
            (input)="searchbyname($event.target.value)"
          />
        </div>

        <!-- Search field for Site Name -->
        <div class="custom_search width_200">
          <input
            type="text"
            class="form-control"
            placeholder="Search by Site Name"
            [(ngModel)]="site"
            (input)="searchbySite($event.target.value)"
          />
        </div>

        <!-- Search field for Application Name -->
        <div class="custom_search width_200">
          <input
            type="text"
            class="form-control"
            placeholder="Search by Application Name"
            [(ngModel)]="application"
            (input)="searchbyApplication($event.target.value)"
          />
        </div>

        <!-- Search field for Device Name -->
        <div class="custom_search width_200">
          <input
            type="text"
            class="form-control"
            placeholder="Search Serial Number"
            [(ngModel)]="sNumber"
            (input)="searchbySerialNo($event.target.value)"
          />
        </div>

        <!-- Search field for Mac Address -->
        <!-- <div class="custom_search width_200">
          <input
            type="text"
            class="form-control"
            placeholder="Search by Mac Address"
            [(ngModel)]="searchMacAddress"
            (input)="searchByFields()"
          />
        </div> -->

        <!-- Add more search fields as needed -->
      </div>
    </div>

    <div>
      <mat-form-field>
        <div class="label">
          <mat-label></mat-label>
        </div>
        <div class="inside">
          <mat-date-range-input [rangePicker]="picker">
            <input
              matStartDate
              [formControl]="range.controls['start']"
              placeholder="Start date"
            />
            <input
              matEndDate
              [formControl]="range.controls['end']"
              placeholder="End date"
            />
          </mat-date-range-input>
        </div>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <button
        mat-raised-button
        color="primary"
        class="custom_button"
        (click)="onDateRangeChange(range.value.start, range.value.end)"
        [disabled]="!range.value.start && !range.value.end"
      >
        Apply Date Range
      </button>

      <button
        mat-raised-button
        color="warn"
        class="custom_button active_clear"
        (click)="clearFilters()"
        [disabled]="
          !(
            clientName != '' ||
            site != '' ||
            application != '' ||
            sNumber != '' ||
            range.value.start != null ||
            range.value.end != null
          )
        "
      >
        Clear Filters
      </button>
    </div>

    <!-- Include similar date picker and buttons for Apply and Clear Filters -->
  </mat-toolbar>

  <!-- Conditionally display no results message -->
  <div class="no_result" *ngIf="serviceData && serviceData.length === 0">
    <p>No service logs found.</p>
  </div>

  <!-- Table to display the service logs -->
  <div
    class="asset_list_view_outer"
    *ngIf="serviceData && serviceData.length > 0"
  >
    <div class="list_view_outer">
      <div class="table-responsive">
        <table class="table table-hover" *ngIf="showEmptyError == ''">
          <thead>
            <tr>
              <th>User Name</th>
              <th>Site Name</th>
              <th>Application Name</th>
              <!-- <th>Device Name</th> -->
              <th>Serial Number</th>
              <th>Service Category</th>
              <!-- <th>Service Detail</th> -->
              <!-- <th>Last Service Performed</th> -->
              <th>Service Performed By</th>
              <!-- <th>Created At</th> -->
              <th>Updated At</th>
              <th>Next Service Date</th>
              <th></th>
              <!-- Add more headers as needed -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of paginatedReportDataArr">
              <td>{{ item.full_name || "N/A" }}</td>
              <td>{{ item.site_name || "N/A" }}</td>
              <td>{{ item.application_name || "N/A" }}</td>
              <td>{{ item.motor_serial_no || "N/A" }}</td>
              <td>{{ item.service_category || "No Action" }}</td>

              <td>{{ item.service_performed_by || "N/A" }}</td>
              <td>{{ item.updated_at || "N/A" }}</td>
              <td>{{ item.next_service_date || "N/A" }}</td>

              <!-- Add more data cells as needed -->
              <td class="text-right">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="viewServiceDetails(item)"
                >
                  Service Details
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="button-container" *ngIf="showEmptyError == ''">
    <button
      mat-raised-button
      color="primary"
      (click)="downloadServiceLogs()"
      [disabled]="serviceData.length === 0"
    >
      Print / Save as PDF
    </button>
  </div>
  <div
    *ngIf="
      showEmptyError !== '' ||
      (paginatedReportDataArr?.length === 0 && filtersApplied)
    "
    class="no_result"
  >
    <p
      style="font-size: 16px; color: #838383; text-align: center; padding: 30px"
    >
      {{ showEmptyError || "No records available for this filter criteria" }}
    </p>
  </div>

  <!-- Pagination controls, if needed -->
  <div class="d-flex justify-content-center" *ngIf="showEmptyError == ''">
    <!-- At the bottom of your service logs table -->
    <mat-paginator
      [length]="filteredServiceData.length"
      [pageSize]="itemsPerPage"
      [pageSizeOptions]="[5, 10, 20]"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
</div>
